<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.show.action`)"
    :toasts="toasts"
    :background="model.data ? 'url(\'' + model.data.attributes.background_url + '\')' : 'none'"
    :resource="model"
  >
    <div class="row px-4" v-if="!model.data.attributes.parent_id && model.data.collections.children">
      <div v-for="(model) in model.data.collections.children.data" class="col-6 col-md-3 px-2 py-0">
        <Link :href="route(`${routePrefix}.video-categories.show`, { video_category: model.data.id })" class="card category-card">
          <img :src="model.data.attributes.image_url" />
          <div class="card-title">
            {{ model.data.attributes.title }}
          </div>
        </Link>
      </div>
    </div>
    <div class="row px-4" v-else-if="!Object.keys(model.data.collections.children.data).length && Object.keys(model.data.collections.videos.data).length > 0">

      <div v-for="(model) in model.data.collections.videos.data" class="col-6 col-md-3 px-2 py-0">
        <Link :href="route(`${routePrefix}.videos.show`, { video: model.data.attributes.slug ?? model.data.id })" class="card category-card">
          <img :src="model.data.attributes.image_url" />
          <div class="card-title">
            {{ model.data.attributes.title }}
          </div>
        </Link>
      </div>
    </div>
    <div v-else-if="model.data?.collections.children" class="card shadow rounded-corner">
      <div class="card-body position-relative pb-1">
        <div class="card-title category-video">
          {{ model.data.attributes.title }}
        </div>
        <div class="p-4"></div>
        <div class="video-container">
          <iframe :src="model.data.attributes.default_video_url" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px;max-height: calc(100vh - var(--forgeron-header-height));"></iframe>
        </div>
        <resource-collection
            v-if="Object.keys(model.data.collections.children.data).length > 0"
            :collection-type="'carousel'"
            :filter="children.filter"
            :foreign-name="foreignName"
            :options="{ targetAttribute: 'display_video_url', titleAttribute: 'title', imageAttribute: 'image_url' }"
            :mode="'component'"
            :models="model.data.collections.children"
            :name="name"
            :sort="children.sort"
        ></resource-collection>
      </div>
    </div>
  </Layout>
</template>

<script>
import Card from '@/structures/default/components/Base/Card';
import FooterContent from '@/structures/moviary/components/Custom/FooterContent';
import HeaderContent from '@/structures/moviary/components/Custom/HeaderContent';
import { Link } from '@inertiajs/vue3';
import MediaCollection from '@/structures/default/components/Presentation/MediaCollection.vue';
import Layout from '@/structures/moviary/Pages/Layout';
import ResourceActionButtons from '@/structures/default/components/Links/ResourceActionButtons';
import ResourceCollection from '@/structures/default/components/ResourceCollection';
import { ref } from 'vue';

export default {
  components: {
    Card,
    FooterContent,
    HeaderContent,
    Layout,
    Link,
    MediaCollection,
    ResourceActionButtons,
    ResourceCollection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    children: { type: Object, default: () => {} },
    resourceType: { type: String, default: '' },
    sort: { type: String, default: 'id' },
    filter: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['addToast'],
  setup(props) {
    const localModel = ref(props.model);

    return {
      localModel,
    };
  },
};
</script>
